import { ViewModel, View } from "binder";
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";


export class PersonnelSearchableSelectorViewModel extends SearchableSelectorBaseViewModel<personnelForSelector> {

    constructor(parentViewModel: ViewModel, showActive: boolean, warehouseId: string, showWarehouseManager: boolean,
        showWarehouseWorker: boolean, canSeeReaports: boolean, canSeeBalancesInPopup: boolean, showAll: boolean) {
        super(parentViewModel);
        this.showActive = showActive;
        this.warehouseId = stringIsNullOrEmpty(warehouseId) ? '00000000-0000-0000-0000-000000000000' : warehouseId;
        this.warehouseManager = showWarehouseManager;
        this.warehouseWorker = showWarehouseWorker;
        this.seeReports = canSeeReaports;
        this.seeBalancesInPopup = canSeeBalancesInPopup;
        this.showAll = showAll;
    }

    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId; } private _warehouseId: string;
    public set showActive(v: boolean) { this._showActive = v; } public get showActive(): boolean { return this._showActive; } private _showActive: boolean;
    public set warehouseManager(v: boolean) { this._warehouseManager = v; } public get warehouseManager(): boolean { return this._warehouseManager; } private _warehouseManager: boolean;
    public set warehouseWorker(v: boolean) { this._warehouseWorker = v; } public get warehouseWorker(): boolean { return this._warehouseWorker; } private _warehouseWorker: boolean;
    public set seeReports(v: boolean) { this._seeReports = v; } public get seeReports(): boolean { return this._seeReports; } private _seeReports: boolean;
    public set seeBalancesInPopup(v: boolean) { this._seeBalancesInPopup = v; } public get seeBalancesInPopup(): boolean { return this._seeBalancesInPopup; } private _seeBalancesInPopup: boolean;
    public set showAll(v: boolean) { this._showAll = v; } public get showAll(): boolean { return this._showAll; } private _showAll: boolean;

    protected async loadData(searchedText: string): Promise<personnelForSelector[]> {
        let result = await ServerConnection.callServer('Complex/EnterpriseAdministrationServices/SearchPersonnels', {
            SearchText: searchedText,
            ResultCount: 20,
            ShowAll: this.showAll,
            WarehouseId: this.warehouseId,
            ShowActive: this.showActive,
            WarehouseManager: this.warehouseManager,
            WarehouseWorker: this.warehouseWorker,
            SeeBalancesInPopup: this.seeBalancesInPopup,
            SeeReports: this.seeReports
        });
        return result.Personnels.map(x => this.convertSingle(x));
    }
    protected async loadById(id: string): Promise<personnelForSelector> {
        let result = await ServerConnection.callServer('Complex/EnterpriseAdministrationServices/SearchPersonnelsById', {
            Id: id
        });
        return this.convertSingle(result.Personnel);
    }

    private convertSingle(dto: any): personnelForSelector {
        var p = new personnelForSelector(this);
        p.id = dto.Id;
        p.name = dto.Name ?? '';
        p.lastName = dto.LastName ?? '';
        p.code = dto.PersonnelCode ?? '';
        p.nationalCode = dto.NationalCode ?? '';
        p.title = `${p.code} - ${p.name} ${p.lastName}`;
        return p;
    }
}

export class PersonnelSelectorViewModel extends SelectorBaseViewModel<personnelForSelector> {
    constructor(parentViewModel: ViewModel, showActive: boolean, warehouseId: string, showWarehouseManager: boolean,
        showWarehouseWorker: boolean, canSeeReaports: boolean, canSeeBalancesInPopup: boolean, showAll: boolean, autoRefresh:boolean=true) {
        super(parentViewModel, true);
        this.showActive = showActive;
        this.warehouseId = stringIsNullOrEmpty(warehouseId) ? '00000000-0000-0000-0000-000000000000' : warehouseId;
        this.warehouseManager = showWarehouseManager;
        this.warehouseWorker = showWarehouseWorker;
        this.seeReports = canSeeReaports;
        this.seeBalancesInPopup = canSeeBalancesInPopup;
        this.showAll = showAll;
        if(autoRefresh == true){
            this.refresh();
        }
    }

    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId; } private _warehouseId: string;
    public set showActive(v: boolean) { this._showActive = v; } public get showActive(): boolean { return this._showActive; } private _showActive: boolean;
    public set warehouseManager(v: boolean) { this._warehouseManager = v; } public get warehouseManager(): boolean { return this._warehouseManager; } private _warehouseManager: boolean;
    public set warehouseWorker(v: boolean) { this._warehouseWorker = v; } public get warehouseWorker(): boolean { return this._warehouseWorker; } private _warehouseWorker: boolean;
    public set seeReports(v: boolean) { this._seeReports = v; } public get seeReports(): boolean { return this._seeReports; } private _seeReports: boolean;
    public set seeBalancesInPopup(v: boolean) { this._seeBalancesInPopup = v; } public get seeBalancesInPopup(): boolean { return this._seeBalancesInPopup; } private _seeBalancesInPopup: boolean;
    public set showAll(v: boolean) { this._showAll = v; } public get showAll(): boolean { return this._showAll; } private _showAll: boolean;

    protected async loadData(): Promise<personnelForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllPersonnels', {
            ShowAll: this.showAll,
            WarehouseId: this.warehouseId,
            ShowActive: this.showActive,
            WarehouseManager: this.warehouseManager,
            WarehouseWorker: this.warehouseWorker,
            SeeBalancesInPopup: this.seeBalancesInPopup,
            SeeReports: this.seeReports
        });
        return result.Personnels.map(q => {
            let result = new personnelForSelector(this);
            result.id = q.Id;
            result.title = q.Name + ' ' + q.LastName;
            result.name = q.Name;
            result.lastName = q.LastName;
            result.code = q.Code;
            result.nationalCode = q.NationalCode;
            return result;
        });
    }
}

export class personnelForSelector extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set lastName(v: string) { this._lastName = v; } public get lastName(): string { return this._lastName; } private _lastName: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode; } private _nationalCode: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}

